import { Controller } from "stimulus"

export default class extends Controller {
  static targets = [
    "selectAll",
    "vehicleCheckbox",
    "selectedCount",
    "triggerBtn",
    "confirmBtn",
    "modalSelectedCount",
    "form"
  ]

  connect() {
    this.updateCount()
  }

  selectAllChanged(event) {
    const checked = event.currentTarget.checked
    this.vehicleCheckboxTargets.forEach(cb => { cb.checked = checked })
    this.updateCount()
  }

  updateCount() {
    const checkedCount = this.vehicleCheckboxTargets.filter(cb => cb.checked).length
    if (this.hasSelectedCountTarget) this.selectedCountTarget.textContent = `${checkedCount} unidades`
    if (this.hasModalSelectedCountTarget) this.modalSelectedCountTarget.textContent = checkedCount
    if (this.hasTriggerBtnTarget) this.triggerBtnTarget.disabled = checkedCount === 0
  }

  confirmSubmit() {
    if (!this.hasConfirmBtnTarget || !this.hasFormTarget) return
    this.confirmBtnTarget.disabled = true
    this.confirmBtnTarget.innerHTML = '<span class="spinner-border spinner-border-sm mr-2" role="status" aria-hidden="true"></span>Enviando...'
    this.formTarget.submit()
  }
}
